/**
 * Released Media Key Status.
 *
 *
 * @beta
 */
export const RELEASED = 'released'
